import { Platform } from 'react-native';

/**
 * Props that make a `View`/`Animated.View` claim the touch responder so a parent
 * Pressable/ScrollView doesn't also react to the gesture (e.g. tapping inside a modal
 * shouldn't trigger the backdrop's dismiss `onPress`).
 *
 * On web this is a no-op: react-native-web does not wire the RN responder handlers
 * (`onStartShouldSetResponder`, `onResponderGrant`, …) to the DOM, and under React 19
 * passing them through logs `Unknown event handler property … It will be ignored`.
 * Spreading an empty object on web keeps the markup clean and silences those warnings
 * while preserving the real responder behaviour on native.
 *
 * Usage: `<View {...claimTouchResponder}>…</View>`
 */
export const claimTouchResponder = Platform.OS === 'web'
	? {}
	: { onStartShouldSetResponder: (): boolean => true };
